import { playableItemEvents } from "../../events";
import PlayableItem from "./item";
import bus from "../../../bus";
import { playerEvents } from "../../events";

export default class PlayableStream extends PlayableItem {
  constructor(props) {
    super(props);
    this.refreshQuantity = -1;
    // Bind event handlers to instance
    this.onReady = this.onReady.bind(this);
    this.onReadyTimeout1 = this.onReadyTimeout1.bind(this);
    this.onReadyTimeout2 = this.onReadyTimeout2.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
    this.onStop = this.onStop.bind(this);
    this.onEnded = this.onEnded.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.onDestroy = this.onDestroy.bind(this);
    this.load = this.load.bind(this);
    this.ready = false;
    this.set(props);
  }

  set(props) {
    this.prevProps = this.props || {};
    this.props = props;
    this.onUpdate();
  }

  isReady() {
    return this.ready;
  }

  onUpdate() {
    const { status, volume } = this.props;
    if (status !== this.prevProps.status) {
      switch (status) {
        case "playing":
          this.play();
          break;
        case "paused":
          this.pause();
          break;
        case "stopped":
          this.stop();
          break;
        default:
          break;
      }
    }
    // Adjust volume
    if (this.ready) {
      if (isFinite(volume)) {
        this.sound.volume = volume;
      }
      this.sound.muted = volume === 0;
    }
  }

  play() {
    if (this.ready && this.sound && this.sound.paused) {
      console.log("play when is ready");
      this.sound.play().catch(err => {
        bus.emit(playerEvents.PAUSE);
      });
    } else if (this.isIphone() && this.sound && this.sound.paused) {
      console.log("Play whe is iphone");
      this.sound.play().catch(err => {
        bus.emit(playerEvents.PAUSE);
      });
    }
  }

  stop() {
    if (this.ready) {
      this.sound.pause();
    }
  }

  pause() {
    if (this.ready) {
      this.sound.pause();
    }
  }

  load() {
    this.isIphone() ? this.onReady() : (this.sound && this.sound.load());
  }

  onCreate({ audio, source }) {
    // Add timeout
    this.readyTimeout1 = setTimeout(this.onReadyTimeout1, 20 * 1000);
    this.sound = audio;
    // Bind event handlers
    this.sound.addEventListener("canplay", this.onReady);
    this.sound.addEventListener("play", this.onPlay);
    this.sound.addEventListener("pause", this.onPause);
    this.sound.addEventListener("ended", this.onEnded);
    // Bind source
    this.soundSrc = source;
    this.soundSrc.addEventListener("error", this.onError);
    // Explicitly call load https://developers.google.com/web/updates/2017/02/media-session
    // if browser is iOS use method play() to load audio file, else use load()
    console.info("isIphone", this.isIphone());
    this.load();
  }

  onDestroy() {
    super.onDestroy();
    this.ready = false;
    this.stop();
    this.sound.removeEventListener("canplay", this.onReady);
    this.sound.removeEventListener("play", this.onPlay);
    this.sound.removeEventListener("pause", this.onPause);
    this.sound.removeEventListener("ended", this.onEnded);
    this.soundSrc.removeEventListener("error", this.onError);
    this.sound = null;
    // el.innerHTML = "";
    clearTimeout(this.readyTimeout);
  }

  hasDuration() {
    return false;
  }

  onReady() {
    clearTimeout(this.readyTimeout1);
    clearTimeout(this.readyTimeout2);
    this.ready = true;
    this.tick();
    const { status } = this.props;
    switch (status) {
      case "playing":
        this.play();
        break;
      case "paused":
        this.pause();
        break;
      case "stopped":
        this.stop();
        break;
      default:
        break;
    }
  }

  onReadyTimeout1() {
    if (!this.ready) {
      this.load();
      this.readyTimeout2 = setTimeout(this.onReadyTimeout2, 20 * 1000);
    }
  }

  onReadyTimeout2() {
    this.refreshQuantity = this.refreshQuantity + 1;
    if (!this.ready) {
      this.onError();
    }
  }

  onPlay() {
    this.emit(playableItemEvents.STATUS_CHANGE, { status: "playing" });
  }
  onPause() {
    this.emit(playableItemEvents.STATUS_CHANGE, { status: "paused" });
  }
  onStop() {
    this.emit(playableItemEvents.STATUS_CHANGE, { status: "stopped" });
  }
  onEnded() {
    this.emit(playableItemEvents.STATUS_CHANGE, { status: "ended" });
  }

  isIphone() {
    return (
      /CriOS/i.test(window.navigator.userAgent) ||
      /FxiOS/i.test(window.navigator.userAgent) ||
      /iPhone/.test(window.navigator.userAgent)
    );
  }

  getPlayerItemID() {
    const { stream } = this.props;
    return stream.id;
  }

  getTitle() {
    const { stream } = this.props;

    if (stream.current_item_name) {
      return stream.current_item_name;
    } else {
      return stream.name;
    }
  }

  getDuration() {
    return this.sound ? this.sound.duration() : 0;
  }

  getCurrentTime() {
    return 0;
  }

  isLive() {
    return true;
  }

  key() {
    const { stream, listenSessionID } = this.props;
    // FIXME The `key` means we only create new vnodes when we get new data, but
    // like we should really do that ourselves so we don’t have to rely on the
    // hyperapp lifecycle methods
    return this.props ? `stream__${stream.id}__${listenSessionID}` : "";
  }

  render() {
    return {
      title: this.getTitle(),
      sourceURL: this.props.stream.stream_url
    };
  }
}
